import { render, staticRenderFns } from "./PlayerMesas.vue?vue&type=template&id=c9fd4ff4&"
import script from "./PlayerMesas.vue?vue&type=script&lang=js&"
export * from "./PlayerMesas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports